import type { Jai1Config } from '../types/framework.types.js';
import type { VaultEncryptedItem, VaultKeyring } from '../types/vault.types.js';
import { NetworkError } from '../errors/index.js';

export interface VaultSyncPushRequest {
    keyring: VaultKeyring;
    items: VaultEncryptedItem[];
    device?: {
        deviceId: string;
        deviceName: string;
        publicKey: string;
        fingerprint: string;
    };
}

export class VaultSyncService {
    async push(config: Jai1Config, request: VaultSyncPushRequest): Promise<{ success: boolean; updatedAt: string }> {
        const response = await fetch(`${config.apiUrl.replace(/\/$/, '')}/api/vault/sync`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'JAI1-Access-Key': config.accessKey,
            },
            body: JSON.stringify(request),
        });
        if (!response.ok) throw new NetworkError(await this.readError(response));
        return await response.json() as { success: boolean; updatedAt: string };
    }

    async pull(config: Jai1Config): Promise<{ keyring: VaultKeyring | null; items: VaultEncryptedItem[] }> {
        const response = await fetch(`${config.apiUrl.replace(/\/$/, '')}/api/vault/sync`, {
            headers: { 'JAI1-Access-Key': config.accessKey },
        });
        if (!response.ok) throw new NetworkError(await this.readError(response));
        const data = await response.json() as { success: boolean; keyring: VaultKeyring | null; items: VaultEncryptedItem[] };
        return { keyring: data.keyring, items: data.items };
    }

    private async readError(response: Response): Promise<string> {
        try {
            const data = await response.json() as { message?: string; error?: string };
            return data.message || data.error || `HTTP ${response.status}`;
        } catch {
            return `HTTP ${response.status}`;
        }
    }
}

